// extracted by mini-css-extract-plugin
export default {"root":"AC9kioPUJxfdxr3WYXpZ","placeHolderShimmer":"G_CkMKCddZ13MfI0UvDF"};